import { journeyAction, } from './base';

import { JourneyActionSetField as JourneyActionSetFieldBase, } from 'atlas-shared';

export const JourneyActionSetField = journeyAction({
  ...JourneyActionSetFieldBase,
  icon: 'Save',
});
